import React from 'react';
import { getIn, toJs, get } from 'mori';
import { withAnyCursor, cursorValueHasChanged } from 'atom/cursors';
import { appState } from 'state';
import { fetch, remove } from 'src/services/pos-checkout-summary';
import { TipSummaryDialog } from 'src/components/reports/transactions/transaction-summary/tip-summary';
import { ReceiptCopyDialog } from 'components/pos/ReceiptCopyDialog/ReceiptCopyDialog';

interface TipSummaryContainerProps {
  checkoutId: number;
  onClose: () => void;
}

interface TipSummaryContainerState {
  checkoutSummary: any;
  showReceiptCopy: boolean;
}

export class TipSummaryContainer extends React.Component<
  TipSummaryContainerProps,
  TipSummaryContainerState
> {
  state: TipSummaryContainerState = {
    checkoutSummary: getIn(appState.deref(), ['checkout-summary', this.props.checkoutId]),
    showReceiptCopy: false,
  };

  componentDidMount() {
    appState.addWatch(
      'TipSummaryContainer',
      withAnyCursor(
        () => {
          this.setState({
            checkoutSummary: getIn(appState.deref(), ['checkout-summary', this.props.checkoutId]),
          });
        },
        [['checkout-summary']],
        cursorValueHasChanged,
      ),
    );
    fetch(this.props.checkoutId);
  }

  componentWillUnmount() {
    appState.removeWatch('TipSummaryContainer');
    remove(this.props.checkoutId);
  }

  render() {
    const { onClose } = this.props;
    const { checkoutSummary, showReceiptCopy } = this.state;

    const tipReceiptUri = checkoutSummary
      ? toJs(get(checkoutSummary, 'checkoutInformation'))?.receiptUri
      : null;

    return (
      <>
        <TipSummaryDialog
          data={checkoutSummary}
          onClose={onClose}
          onReceiptCopy={() => this.setState({ showReceiptCopy: true })}
        />
        {showReceiptCopy && tipReceiptUri && (
          <ReceiptCopyDialog
            onClose={() => this.setState({ showReceiptCopy: false })}
            receiptCopyUri={tipReceiptUri}
          />
        )}
      </>
    );
  }
}
